module.exports = __webpack_public_path__ + "img/20200513_161250.3fc0bc7e.jpg";